module.exports = __webpack_public_path__ + "img/new-logo.7e4bb4dc.png";